import { IConfigStorage } from "../../../Common/IConfigStorage";
import { IDataDefinition } from "../../../Common/Data/Definitions/IDataDefinition";
import { ValidationIssue } from "../../../Common/IDesignValidationProvider";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class ResultCell implements IConfigStorage {
    _columnId: string;
    value: AppGlueAny;

    constructor(columnId: string) {
        this._columnId = columnId;
    }

    getStorageData(): object {
        let data = {};
        Reflect.set(data, "_columnId", this._columnId);
        Reflect.set(data, "value", this.value);
        return data;
    }

    setStorageData(data: object): void {
        this._columnId = Reflect.get(data, "_columnId");
        this.value = Reflect.get(data, "value");
    }

    validateCellData(datadef: IDataDefinition): ValidationIssue[] {
        let issues: ValidationIssue[] = [];
        if (this.value === undefined || this.value === null) issues.push(new ValidationIssue("value is required"));
        else if (datadef.verifyValueType(this.value)) {
            issues.push(new ValidationIssue("Invalid data type"));
        }
        return issues;
    }
}
